import getIn from 'transmute/getIn';
import { TICKET_SOURCES } from '../constants/KeyPaths';
export const getAsyncTicketSources = getIn(TICKET_SOURCES);